import React from 'react';
import { AppRoutes } from './routes/AppRoutes';

export const App: React.FC = () => {
  return <AppRoutes />;
};
